var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar-title',{staticClass:"v-toolbar-title"},[(_vm.disabledRedirect)?_c('div',{staticClass:"toolbar-title"},[_c('img',{staticClass:"logo-stampyt",attrs:{"src":_vm.src,"alt":_vm.alt}})]):_c('router-link',{staticClass:"toolbar-title",attrs:{"to":_vm.path}},[_c('img',{staticClass:"logo-stampyt",attrs:{"src":_vm.src,"alt":_vm.alt}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }